<div class="tour-scrim" (click)="skip()" aria-hidden="true"></div>

@if (spot) {
  <div
    class="tour-spot"
    [style.top.px]="spot.top"
    [style.left.px]="spot.left"
    [style.width.px]="spot.width"
    [style.height.px]="spot.height"
    aria-hidden="true"
  ></div>
}

<section
  class="tour-card"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'Tour step ' + (index + 1) + ' of ' + steps.length + ': ' + step.title"
  [style.top.px]="card.top"
  [style.left.px]="card.left"
>
  <header class="tour-head">
    <span class="tour-progress">{{ index + 1 }} / {{ steps.length }}</span>
    <button type="button" class="tour-close" (click)="skip()" aria-label="Close tour">
      <i class="bx bx-x" aria-hidden="true"></i>
    </button>
  </header>
  <h3 class="tour-title">{{ step.title }}</h3>
  <p class="tour-body">{{ step.body }}</p>
  <footer class="tour-foot">
    <button type="button" class="tour-btn tour-btn--ghost" (click)="skip()">Skip</button>
    <span class="tour-spacer"></span>
    @if (index > 0) {
      <button type="button" class="tour-btn tour-btn--ghost" (click)="back()">Back</button>
    }
    <button type="button" class="tour-btn tour-btn--primary" (click)="next()">
      {{ isLast ? 'Done' : 'Next' }}
    </button>
  </footer>
</section>
